//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import { ucWebPath } from '@/config/project-config'
import { Toast } from 'vant'
import wxlogin from 'vue-wxlogin';
import { appId } from '@/config/project-config'
export default {
  name: 'login',
  components: {
    wxlogin,Header,Footer
  },
  data() {
    return {
      appId: appId,
      userPhone: '', // 手机号
      password: '', // 验证码
      second: 59, // 倒计时数字
      timeFlag: false // 验证码开关
    };
  },
  created () {
  },
  methods: {
    fnGoToLoginPage(type) { // 跳转到微信登录
      this.$router.push({path:"login"})
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/wxScan.vue